/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1660
 */

var /* [auto-meaningful-name] */_1$$valueOf = 1..valueOf
module.exports = function (e) {
  return _1$$valueOf.call(e)
}
